export default {
  disasterAuthorization: {
    title: 'Authorization',
    text: 'Please select your data provider and enter the corresponding key of your HeiGIT Disaster Portal user. If you don\'t already have a user, request one by sending an email to support[at]openrouteservice.heigit.org, specifying your use case. Even without a key, the app can be used in read-only mode.',
    save: 'Save',
    enterTheAuthorizationKey: 'Enter the authorization key',
    selectProvider: 'Select your data provider',
    authenticateAsAdmin: 'Activate administration mode here',
    useReadOnly: 'Use in read-only mode',
    insertAValidKey: 'A valid key must be inserted',
    insertAProvider: 'A provider matching your authorization must be chosen'
  }
}
